/**
 * quizJournee2Am.js — Quiz d'ancrage Permis AM · Journée 2 Cyclomoteur
 * 10 QCM alignés sur le contenu réel du cours (insertion, anticipation, intersections, giratoires,
 * usagers vulnérables, communication…).
 */
export const quiz = {
  id: 'permis-am-j2',
  title: "Quiz d'ancrage · Journée 2 AM",
  color: '#dc2626',
  cours: '/cours/permis-am-journee-2',
  questions: [
    {
      q: "Avant de démarrer ton cyclomoteur, que dois-tu vérifier en priorité ?",
      choices: [
        "Le niveau d'huile uniquement",
        "Équipement + pneus + éclairage + freins + rétroviseurs",
        "Uniquement l'essence",
        "Rien, le contrôle technique suffit",
      ],
      answer: 1,
      explain: "Ta conduite commence avant de démarrer. Une routine complète : équipement, pneumatiques, éclairage, clignotants, rétroviseurs, freins.",
    },
    {
      q: "Pour t'insérer dans la circulation, quelle est la méthode enseignée ?",
      choices: [
        "Foncer dès qu'il y a un trou",
        "Observer → Évaluer → Décider → S'insérer",
        "Attendre que l'enseignant dise « vas-y »",
        "Klaxonner et partir",
      ],
      answer: 1,
      explain: "OBSERVER → ÉVALUER → DÉCIDER → S'INSÉRER. Cette séquence te rend autonome pour choisir toi-même le bon moment.",
    },
    {
      q: "Pourquoi apprendre à « regarder loin » et pas uniquement devant toi ?",
      choices: [
        "Pour aller plus vite",
        "Pour découvrir les situations trop tard",
        "Pour anticiper : plus tôt tu vois, plus tu as de temps pour décider",
        "Parce que c'est plus reposant",
      ],
      answer: 2,
      explain: "PRÈS + LOIN + AUTOUR. Signalisation, intersections, piétons, portières, ralentissements — tu vois en avance, tu décides sereinement.",
    },
    {
      q: "En approche d'une intersection, la bonne allure est celle qui :",
      choices: [
        "Correspond à la limite du panneau",
        "Est déjà réduite pour te laisser une solution",
        "Te permet d'y arriver le plus vite possible",
        "Ne change jamais",
      ],
      answer: 1,
      explain: "Tu adaptes ton allure AVANT le danger. Si quelque chose arrive maintenant, ai-je le temps de réagir ?",
    },
    {
      q: "Avant d'entrer dans un giratoire, tu dois déjà savoir :",
      choices: [
        "Quelle est ta sortie",
        "S'il y a un radar",
        "S'il y a un feu",
        "S'il pleut ailleurs",
      ],
      answer: 0,
      explain: "AVANT L'ENTRÉE : allure, sortie choisie, signalisation lue. Ne regarde pas seulement où tu es, cherche où tu vas.",
    },
    {
      q: "Avoir la priorité, cela veut dire :",
      choices: [
        "Que tu peux passer sans regarder",
        "Que les autres doivent forcément te céder le passage",
        "Que tu peux passer, mais tu continues d'observer",
        "Que tu peux accélérer",
      ],
      answer: 2,
      explain: "AVOIR LA PRIORITÉ NE SIGNIFIE JAMAIS QUE TU PEUX ARRÊTER D'OBSERVER. La priorité se prend prudemment, jamais aveuglément.",
    },
    {
      q: "Les usagers vulnérables (piétons, cyclistes, enfants) demandent :",
      choices: [
        "Un klaxon plus fort",
        "Plus de vigilance, plus d'espace, plus d'anticipation",
        "Aucune attention particulière",
        "De rouler plus vite pour les dépasser",
      ],
      answer: 1,
      explain: "Un piéton ou un cycliste peut avoir un comportement imprévu. Tu leur laisses de l'espace, tu ralentis, tu es prêt à réagir.",
    },
    {
      q: "« Voir ce que tu ne vois pas », c'est apprendre à :",
      choices: [
        "Regarder derrière toi tout le temps",
        "Identifier les zones masquées où quelqu'un peut surgir",
        "Fermer un œil sur deux",
        "Ignorer les angles morts, c'est réservé aux camions",
      ],
      answer: 1,
      explain: "Portière qui s'ouvre, piéton masqué par un véhicule, enfant derrière une camionnette… Tu anticipes les zones où un danger peut apparaître.",
    },
    {
      q: "Pour te rendre visible et communiquer avec les autres, tu dois :",
      choices: [
        "Rester au milieu de la file, feux éteints",
        "Utiliser tes clignotants tôt, te positionner clairement, croiser les regards",
        "Uniquement klaxonner",
        "Rouler collé au véhicule devant",
      ],
      answer: 1,
      explain: "Clignotants annoncés à l'avance, positionnement clair, regard échangé avec les autres — tu deviens prévisible et donc plus sûr.",
    },
    {
      q: "À la fin de la journée 2, tu deviens conducteur autonome parce que :",
      choices: [
        "Tu roules sans casque",
        "Tu prends progressivement tes propres décisions : observer, anticiper, décider, agir",
        "Tu suis toujours ton enseignant à la lettre",
        "Tu roules le plus vite possible",
      ],
      answer: 1,
      explain: "L'enseignant te guide moins, tu prends davantage de décisions par toi-même. C'est ça devenir conducteur.",
    },
  ],
};

export default quiz;
